export const mutations = {
    set_sucursales(state, data) {
        state.sucursales = data
    },
    set_sucursal_seleccionada(state, data) {
        state.sucursal_seleccionada = data
    }

}
